<div class="breadcrumb">
  @for (breadcrumb of breadcrumbs; track breadcrumb; let first = $first; let last = $last) {
    <li
      [class.active]="last || !breadcrumb.Url">
      @if (breadcrumb.Url && !last) {
        <a [routerLink]="breadcrumb.Url">
          @if (!first) {
            <i class="__icon">
              <img src="assets/img/breadcrumb_arrow_icon.png" alt="">
            </i>
          }
          <span class="__rest">{{breadcrumb.Label}}</span>
        </a>
      } @else {
        @if (!first) {
          <i class="__icon">
            <img src="assets/img/breadcrumb_arrow_icon.png" alt="">
          </i>
        }
        <span class="__current">{{breadcrumb.Label}}</span>
      }
    </li>
  }
</div>
<!-- <h2 class="page_heading">{{Title}}</h2> -->
<!-- <h2 class="page_heading" style="">dropdown</h2> -->